import React from 'react'
import { connect } from 'react-redux'

import _ from 'underscore'

import Navigator from '../app/navigator'

import { PercentileType } from '../domain/ReportCriteria'
import ActualGraph from './graph/tooltip-graph'
import Snapshot from './snapshot/snapshotModel'
import { ApplicationState } from '../redux/ApplicationState'
import { getMonitorGraph } from '../redux/monitor/MonitorState'
import { TidewaysContext } from '../app/context'

interface OwnProps {
    responseType: PercentileType
    service?: string
    shareTimeslot?: (activeTimeslot: string | null) => void
    sharedTimeslot?: string | null
}

interface StateProps {
    navigator: Navigator
    parameters: { [key: string]: string }
    loading: boolean
    data: any
    tidewaysContext: TidewaysContext
}

type Props = OwnProps & StateProps

class ExternalCallsGraph extends React.Component<Props> {
    public static defaultProps = {
        loading: false,
        data: null,
    }

    private chart: HTMLDivElement | null

    private redirect = (params, route) => {
        // if props.service is set, we are on the service-overview page (s=__all)
        // so when redirecting, we want to overwrite the service to make sure we land on the proper
        // page for selected events and especially snapshot views
        if (this.props.service) {
            this.props.tidewaysContext.setService(this.props.service)
            params['s'] = this.props.service
        }

        this.props.navigator.push(params, route)
    }

    public componentDidMount() {
        if (!this.chart) {
            return
        }

        jQuery(this.chart).on('eventClicked', (e, event) => {
            this.redirect({ event: event.id, events: _.pluck(event.group, 'id').join(',') }, 'XhprofOrganizationBundle.Application.show')
        })

        jQuery(this.chart).on('rangeSelected', (e, dataSet, nextDataSet) => {
            this.redirect(Snapshot.fromDataSets(dataSet, nextDataSet).toParameters(), 'XhprofProfilerBundle.Snapshot.show')
        })

        jQuery(this.chart).on('rangeDelesect', e => {
            this.redirect({ date: null, end: null }, 'XhprofOrganizationBundle.Application.show')
        })
    }

    public render() {
        return (
            <div
                className="external-monitoring-graph"
                ref={element => {
                    this.chart = element
                }}
            >
                <ActualGraph {...this.props} hasDownstream={false} />
            </div>
        )
    }
}

export default connect<StateProps>((globalState: ApplicationState, props: OwnProps) => {
    const { tidewaysContext } = globalState
    const graph = getMonitorGraph(globalState, props.service, true)

    return {
        tidewaysContext,
        navigator: new Navigator(globalState.tidewaysContext.route),
        parameters: globalState.tidewaysContext.route.parameters,
        ...graph,
    }
})(ExternalCallsGraph)
